import { Injectable } from '@angular/core';
import { Toast } from '../types/toast';
import { ToastType } from '../enums/toast-type';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor() {}

  toast: Toast = {
    message: '',
    type: ToastType.success,
    isOpen: false,
    classes: '',
  };

  show(): void {
    this.toast.isOpen = true;

    setTimeout(() => {
      this.toast.isOpen = false;
    }, 3000);
  }

  success(message: string): void {
    this.toast.message = message;
    this.toast.type = ToastType.success;
    this.toast.classes =
      'bg-green-primary text-green-secondary border border-green-secondary';
    this.show();
  }

  error(message: string): void {
    this.toast.message = message;
    this.toast.type = ToastType.error;
    this.toast.classes =
      'bg-red-primary text-red-secondary border border-red-secondary';
    this.show();
  }

  info(message: string): void {
    this.toast.message = message;
    this.toast.type = ToastType.error;
    this.toast.classes =
      'bg-purple-100 text-kek-purple border border-kek-purple';
    this.show();
  }
}
